import { object, string } from "yup";

const ForgotPasswordSchema = object().shape({
    email: string().required("Le champ est requis").email("L'adresse email n'est pas valide"),
});

export default ForgotPasswordSchema;
